import { createSlice } from '@reduxjs/toolkit';

interface DiceState {
  gameId: string | null;
  value: number | null,
  playerId: string | null,
  isLoading: boolean,
}

const initialState: DiceState = {
  gameId: null,
  value: null,
  playerId: null,
  isLoading: false,
}

const diceSlice = createSlice({
  name: 'dice',
  initialState,
  reducers: {
    setGameId: ((state, action) => {
      state.gameId = action.payload.gameId;
    }),
    receiveDice: ((state, action) => {
      if (action.payload) {

        if (state.gameId && state.gameId !== action.payload.gameId) {
          return;
        }

        if (state.value) {
          state.isLoading = true;
        }

        state.value = action.payload.value || initialState.value;
        state.playerId = action.payload.playerId;
      }
    }),
    stopLoading: ((state) => {
      state.isLoading = false;
    }),
    sendDice: ((state, data) => {

    }),
  },
});

export const diceActions = diceSlice.actions;
export default diceSlice.reducer;
